import Environment from "../../../utils/Environment";

// Query params sent to /users/special/stats and /users/special/transactions
export const KAI_PRIVATE_SALE = "KAI-SPECIAL-ROUND";
export const DOP_PRIVATE_SALE = "KAI-DOP-ROUND";

// Kept for backwards compatibility — defaults to the first tab's tag
export const PRIVATE_SALE = KAI_PRIVATE_SALE;

// Static round meta (labels / dates not returned by the stats API).
// `privateSale` is the API tag each tab queries with; `contractAddress` is the
// presale contract the Round Status card reads getRoundCount() / rounds() from.
// `saleLabel` overrides the raw API tag wherever it is shown to the user.
export const CREDIT_REFUND_ROUND = {
  key: "creditrefundeligibility",
  title: "Credit Refund Eligibility Round",
  privateSale: KAI_PRIVATE_SALE,
  contractAddress: Environment.PROJECTS_Fixed.KAI.specialRound,
  showCreditsUnlocked: true,
  saleLabel: "KAI Credit Refund",
};

export const DOP_PRIVATE_SALE_USERS_ROUND = {
  key: "dopprivatesaleusers",
  title: "DOP Private Sale Users Round",
  privateSale: DOP_PRIVATE_SALE,
  contractAddress: Environment.specialDopRound,
  showCreditsUnlocked: false,
  // this round pays a x2 bonus: the API's tokenPurchased is the full
  // entitlement, so the purchased figure is half of it.
  showEntitlement: true,
  saleLabel: "DOP Private Sale User",
};

// Kept so existing imports of KAI_SPECIAL_ROUND keep resolving
export const KAI_SPECIAL_ROUND = CREDIT_REFUND_ROUND;

// Round-tab list — order defines tab order
// export const ROUNDS = [DOP_PRIVATE_SALE_USERS_ROUND];
export const ROUNDS = [CREDIT_REFUND_ROUND, DOP_PRIVATE_SALE_USERS_ROUND];

// Maps stats-API token-total fields -> display unit; order defines display order.
// Only non-zero values are shown in the "Purchased Amount" breakdown.
export const TOKEN_BREAKDOWN = [
  { field: "totalEth", unit: "ETH" },
  { field: "totalUsdt", unit: "USDT" },
  { field: "totalUsdc", unit: "USDC" },
  { field: "totalGems", unit: "GEMS" },
  { field: "totalUni", unit: "UNI" },
  { field: "totalPepe", unit: "PEPE" },
  { field: "totalLink", unit: "LINK" },
  { field: "totalTomi", unit: "TOMI" },
  { field: "totalWbtc", unit: "WBTC" },
  { field: "totalDopToken", unit: "DOP" },
];
